<template>
  <div class="contenu-fluide piv--blanc">
    <div class="container">
      <div class="ligne">
        <div class="d-flex align-items-center">
          <a
            href="#contenu"
            class="visuallyHidden"
            tabindex="1"
          >{{
            $tc("application.passerContenu")
          }}</a>
        </div>
      </div>
      <div
        class="ligne"
        id="entetePiv"
      >
        <div class="d-flex align-items-center zone1 container_piv">
          <a
            tabindex="5"
            :href="appStore.modele.urlBase"
          >
            <img
              id="pivImage"
              :src="logoUrl"
              height="72"
              :alt="$t('application.application_logo')"
            />
          </a>
        </div>
        <div
          class="d-flex align-items-center zone2"
          lang="fr"
        ></div>

        <div class="d-flex justify-content-end align-items-center zone3">
          <v-btn
            text
            rounded
            elevation="0"
            style="color: black"
            v-if="inscriptionStore.afficherPanier"
            v-on:click.stop="allerPanier()"
            id="btnPanier"
          >
            {{ $t('Panier.panier') }}
            <v-badge
              overlap
              :content="panierStore.listeCoursPanier.length"
              :value="panierStore.listeCoursPanier.length"
            >
              <v-icon>mdi-cart</v-icon>
            </v-badge>
          </v-btn>

          <!-- Bouton de demande de contact -->
          <v-btn
            v-on:click.stop="allerDemandeContact()"
            icon
            id="btnDemandeContact"
            style="color: black"
            v-if="peutSincrire && !overrideBoiteNousJoindreActif"
          >
            <v-icon>mdi-account-question</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import csqcOutils from '@/outils/CSQCOutils';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';

export default {
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return { appStore, inscriptionStore, panierStore };
  },
  data() {
    return {
      overrideBoiteNousJoindreActif: false,
    };
  },
  methods: {
    EnregistrerLangue() {
      const langueDispo = csqcOutils.GetLangue() === 'fr' ? 'en' : 'fr';
      csqcOutils.SetLanguage(langueDispo);
      // On retourne toujours au url de base après un changement de langue.
      window.location.reload();
    },
    allerDemandeContact() {
      window.location.href =
        `${this.appStore.modele.urlBase}/#/DemandeContact`;
    },
    allerPanier() {
      if (this.panierStore.listeCoursPanier.length > 0) {
        window.location.href = `${this.appStore.modele.urlBase}/#/Panier`;
      } else {
        const message = {
          title: this.$t('boutique.dialog.TitreAvertissement'),
          body: this.$t('boutique.dialog.PanierVide'),
        };

        this.$dialog.alert(message);
      }
    },
  },
  computed: {
    getLangue() {
      if (csqcOutils.GetLangue() === 'fr') return this.$t('application.parametre_anglais');

      return this.$t('application.parametre_francais');
    },
    getUrlBase() {
      return this.appStore.modele.urlBase;
    },
    logoUrl() {
      return csqcOutils.TexteVide(this.appStore.modele.logoUrl) ?
        'https://portail.csqc.ca/portail/images/quebec_couleur.svg' :
        this.appStore.modele.logoUrl;
    },
    peutSincrire() {
      return ((this.appStore.modele.optionRegionale.inscriptionOuverte && !this.appStore.modele.optionRegionale.inscriptionTermine) ||
        (this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine) || // Si pendant les inscription d'examen
        // eslint-disable-next-line max-len
        (!this.appStore.modele.optionRegionale.inscriptionOuverte && this.appStore.modele.optionRegionale.inscriptionTermine && !this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine)); // Si pas commencer mais pas terminé ( entre le moment que inscription normal sont fermé et inscription examen pas commencé)
    },
  },
  created() {
    // Si "BoiteNousJoindre" est overridé, ne pas afficher l'icône pour atteindre la page /DemandeContact
    const dateActuelle = new Date();
    const messageSupportActif = this.appStore.modele.optionRegionale.estActifMessageSupport;
    let dateMessageSupportActive = false;
    if (dateActuelle > new Date(this.appStore.modele.optionRegionale.dateActifMessageSupport)) {
      dateMessageSupportActive = true;
    }

    if (messageSupportActif && dateMessageSupportActive) {
      this.overrideBoiteNousJoindreActif = true;
    }
  },
};
</script>

<style lang="css" scoped>
.container {
  max-width: 1340px;
}

@import url("https://fonts.googleapis.com/css2?family=Passion+One&family=Roboto&display=swap");
</style>
